export const isElementWithinRef = _ref => {
  var _ref$current;
  let {
    ref,
    element
  } = _ref;
  return (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(element);
};
//# sourceMappingURL=isElementWithinRef.js.map